import {getCookie, removePipes} from "@core-ui/utility";
import {
  getShippingAttributes,
  getBounceBackText,
  hasBounceBack,
  hasRewards,
  getCoordinates,
  getZipCode,
} from "./helpers/personalization-adapter-helper";

export const EXTERNAL_CUSTOMER_ID = "cam";

/**
 * Maps relevant stuff for MyAccount from Personalization response,
 * @param rawPersonalizationData JSON from API response
 * @returns {*object} object reflecting Personalization data needed for MyAccount
 * @constructor
 */
export const personalizationAdapter = (marketAgnosticBrandCode) => (data) => {
  const {
    userContext = {},
    customerAccount = {},
    customerAttributes = {},
    featureSelections = {},
    shoppingBag = {},
    marketingMessageInfo = {},
    customerUUID,
    customerId,
    personalizationReferrerInfo = {},
  } = (data || {}).personalizationInfoV1 || {};

  const {isLoggedInUser, isRecognizedUser} = userContext;
  const {firstName} = customerAccount || {};
  const {geoLocation} = marketingMessageInfo;

  const bouncebackActive = hasBounceBack(
    customerAttributes,
    marketAgnosticBrandCode
  );
  const rewardsActive = hasRewards(customerAttributes);
  const bouncebackText = getBounceBackText(marketAgnosticBrandCode);

  return {
    customerId,
    customerUUID,
    externalCustomerId: removePipes(getCookie(EXTERNAL_CUSTOMER_ID)),
    personalizationReferrerInfo: {
      headerReferrerUrl: personalizationReferrerInfo.headerReferrerUrl,
    },
    shoppingBag: {
      totalItemCount: Number(shoppingBag.totalItemCount) || 0,
      totalItemAmount: Number(shoppingBag.totalItemAmount) || 0,
    },
    marketingMessageInfo,
    userContext,
    customerAttributes,
    featureSelections,
    firstName,
    isLoggedInUser: isLoggedInUser === "true",
    isRecognizedUser: isRecognizedUser === "true",
    internationalShipping: {
      ...getShippingAttributes(userContext),
    },
    virtualValueInterrupterStatus: {
      bouncebackActive,
      rewardsActive,
      bouncebackText,
      totalRewardValue:
        parseInt(customerAttributes.totalRewardValue || 0, 10) +
        parseInt(customerAttributes.mtlTotalRewardValue || 0, 10),
    },
    geoCoordinates: getCoordinates(geoLocation),
    // TODO: add support for zipOverride from querystring params
    // to the call to `getZipCode` below
    zipCode: getZipCode(geoLocation, null),
  };
};

export const mapModelData = (model) => {
  const signInButtonText = model["universalNav.signIn"];
  const signOutButtonText = model["universalNav.signOut"];
  const internationalShippingText = model["universalNav.i18lShipping"];
  const internationalCurrentShippingText =
    model["universalNav.currentShipping"];
  const virtualValueRewards = model["virtualvalue.rewards"];
  const virtualValueBounceBack = model["virtualvalue.bounceback"];
  const virtualValueBounceBackAndRewards = model["virtualvalue.bothrewards"];

  return {
    signInButtonText,
    signOutButtonText,
    internationalShippingText,
    internationalCurrentShippingText,
    virtualValueRewards,
    virtualValueBounceBack,
    virtualValueBounceBackAndRewards,
  };
};
